const baseUrl = '/bills';

/**
 * The billing dashboard lives in the same service as bill extraction but behind a different gateway
 * prefix, so its requests override the client base url with this one.
 */
export const billingDashboardBaseUrl = (process.env.BILL_AUTOMATION_API_ENDPOINT || '').replace(/\/bill-automation\/api\/?$/, '/billing/api');
export const billAutomationBillsRoutes = {
  baseUrl: "".concat(baseUrl),
  billById: billId => "".concat(baseUrl, "/").concat(billId),
  /** The bill uploaded for one billing cycle, property and utility — see `getBillForCycle`. */
  billForCycle: "".concat(baseUrl, "/for-cycle"),
  /**
   * A presigned S3 `PUT` for sending a bill file straight to storage, and the call that registers
   * the key it wrote to (LB-5898). Between them the bytes never pass through the API, which is what
   * lifts the upload past the ~4.5 MB a request body can carry to the service.
   */
  billUploadUrl: "".concat(baseUrl, "/upload-url"),
  billFromStorage: "".concat(baseUrl, "/from-storage"),
  companyBills: companyId => "/companies/".concat(companyId, "/bills"),
  companyBillsSummary: companyId => "/companies/".concat(companyId, "/bills/summary"),
  /** What the filter dropdowns can offer, once the table holds one page rather than all of them. */
  companyBillFilterOptions: companyId => "/companies/".concat(companyId, "/bills/filter-options"),
  companyBill: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId),
  /** What a retry of the bill may do, and the retry itself (LB-5787). */
  companyBillRetryOptions: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId, "/retry-options"),
  companyBillRetry: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId, "/retry"),
  /** A bills download (LB-6033): what it would hold, preparing it, and one emailed to the person who asked. */
  companyBillsExportPreview: companyId => "/companies/".concat(companyId, "/bills/exports/preview"),
  companyBillsExports: companyId => "/companies/".concat(companyId, "/bills/exports"),
  companyBillsExport: (companyId, exportId) => "/companies/".concat(companyId, "/bills/exports/").concat(exportId),
  /**
   * Says an upload has no more files coming, so its acquisition event can be reported (LB-5862).
   * Each file goes up in its own request, so no upload request knows it is the last one.
   */
  companyBillsBatchSeal: companyId => "/companies/".concat(companyId, "/bills/batch/seal"),
  appfolioPush: billId => "".concat(baseUrl, "/").concat(billId, "/appfolio-push"),
  attachBill: billId => "".concat(baseUrl, "/").concat(billId, "/attach"),
  /** The bill's blocks of charges and which were matched, for attaching a portfolio bill block by block (LB-5910). */
  attachOptions: billId => "".concat(baseUrl, "/").concat(billId, "/attach-options"),
  /** Save (PUT) and discard (DELETE) a correction — LB-5840. Bill-scoped, so no company id. */
  billEdit: billId => "".concat(baseUrl, "/").concat(billId, "/edit"),
  /**
   * Who changed what. Its own path segment rather than a child of `edit`: the service routes
   * `edit-history` separately, and `edit/history` answers 404 with nothing to say why.
   */
  billEditHistory: billId => "".concat(baseUrl, "/").concat(billId, "/edit-history"),
  appfolioPushStatus: "".concat(baseUrl, "/appfolio-push-status"),
  billAllocations: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId, "/allocations"),
  allocateBill: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId, "/allocate"),
  /** Approving the tables allocating left at "Awaiting approval" — the step that charges residents (LB-6052). */
  approveBill: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId, "/approve"),
  companyBillFileUrl: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId, "/file-url")
};